import { createCacheWrapper } from '@utils/cache';
import { HOURS_TO_MS, DAYS_TO_MS } from '@utils/constants';
import { getPortalList } from './request.get-portal-list.js';
import { getRedirectForUrl } from './request.get-redirect-for-url.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS,
  capacity: 1e4
});
function resolveUrl(url, options) {
  return cache(!(options == null ? void 0 : options.disableCache) ? url : void 0, async () => {
    const parsedUrl = new URL(url);
    if (parsedUrl.hostname === process.env["PM2__PREVIEW_DOMAIN"] || process.env["PM2__LOCAL_ENV"] === "true") {
      const portalId = getFirstFolderFromPath(parsedUrl.pathname);
      const remainingPathname = removeFirstFolderFromPath(parsedUrl.pathname);
      return {
        portalId,
        pathname: remainingPathname,
        baseUrl: `/${portalId}`,
        previewMode: true,
        segments: {
          host: parsedUrl.host,
          hostname: parsedUrl.hostname,
          pathname: remainingPathname,
          search: parsedUrl.search
        },
        canonicalUrl: await getRedirectForUrl(
          portalId,
          {
            host: parsedUrl.host,
            baseUrl: `/${portalId}`,
            pathname: remainingPathname,
            search: parsedUrl.search
          },
          {
            ...options,
            previewMode: true
          }
        )
      };
    }
    const portals = await getPortalList();
    for (const portal of portals) {
      if (portal.primaryDomainName === parsedUrl.hostname) {
        return {
          portalId: portal.id,
          pathname: parsedUrl.pathname,
          previewMode: false,
          segments: {
            host: parsedUrl.host,
            hostname: parsedUrl.hostname,
            pathname: parsedUrl.pathname,
            search: parsedUrl.search
          },
          canonicalUrl: await getRedirectForUrl(
            portal.id,
            {
              host: parsedUrl.host,
              baseUrl: "",
              pathname: parsedUrl.pathname,
              search: parsedUrl.search
            },
            {
              ...options,
              previewMode: false
            }
          )
        };
      }
    }
    for (const portal of portals) {
      for (const alias of portal.aliasDomainNames) {
        if (alias === parsedUrl.hostname) {
          const protocol = hasSSLCertificate(portal.primaryDomainName) ? "https" : "http";
          return {
            portalId: portal.id,
            pathname: parsedUrl.pathname,
            canonicalUrl: `${protocol}://${portal.primaryDomainName}${parsedUrl.pathname}${parsedUrl.search}`,
            previewMode: false,
            segments: {
              host: parsedUrl.host,
              hostname: parsedUrl.hostname,
              pathname: parsedUrl.pathname,
              search: parsedUrl.search
            }
          };
        }
      }
    }
    return void 0;
  }).getStaleWhileRevalidate();
}
function getFirstFolderFromPath(pathname) {
  const trimmedPath = pathname.replace(/^\/+/, "");
  const firstPathSeparatorIndex = trimmedPath.indexOf("/");
  return firstPathSeparatorIndex > 0 ? trimmedPath.substring(0, firstPathSeparatorIndex) : trimmedPath;
}
function removeFirstFolderFromPath(pathname) {
  const trimmedPath = pathname.replace(/^\/+/, "");
  const firstPathSeparatorIndex = trimmedPath.indexOf("/");
  return firstPathSeparatorIndex > 0 ? trimmedPath.substring(firstPathSeparatorIndex) : "/";
}
const CERTIFICATE_WILDCARD_REGEX = /^[^.]+\.(gyldendal|munksgaard|hansreitzel)\.dk$/;
function hasSSLCertificate(domain) {
  return CERTIFICATE_WILDCARD_REGEX.test(domain);
}

export { hasSSLCertificate, resolveUrl };
//# sourceMappingURL=request.resolve-url.js.map
